import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  min-width: 240px;
  width: 240px;
  height: 68px;
  padding: 8px;
  border: 1px solid #d6d7db;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;

  > span {
    margin-left: 16px;
    font-size: 14px;
  }
`

const Card = ({ image, description, onClick }) => {
  return (
    <Container onClick={onClick}>
      {image}
      <span>{description}</span>
    </Container>
  )
}

export default Card
